<template>
    <div>
        <div><a class="form-text text-muted" href="" @click.prevent="display = !display">{{label}}</a></div>
        <ul v-if="display" class="form-text text-muted">
            <li v-for="(desc, name) in vars"><small v-text="`{{${name}}} - ${desc}`"></small></li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: {
            vars: Object
        },
        data() {
            return {
                display: false
            };
        },
        computed: {
            label: function () {
                return (this.display ? 'Hide' : 'Show') + ' available variables';
            }
        }
    }
</script>